import { render, staticRenderFns } from "./AddOtherFilesModal.vue?vue&type=template&id=187fd52a&"
import script from "./AddOtherFilesModal.vue?vue&type=script&lang=js&"
export * from "./AddOtherFilesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports